import React, { useState, useEffect, useRef } from "react";
import { Table, Button, Modal, Tab, Tabs, Container, Row, Col, InputGroup, Form, Pagination } from "react-bootstrap";
import { axiosOpen } from "../../../api/axios";
import Paginations from "../../../component/Paginations/Paginations";

const UserPrompt = () => {
  const userID = JSON.parse(localStorage.getItem("userID"));
  const [promptsList, setPromptsList] = useState([]);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedPrompt, setSelectedPrompt] = useState({});
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const isMounted = useRef(false);

  function showDetailsModalHandler() {
    setShowDetailsModal((value) => !value)
  }

  function handleView(productPrompt) {
    setSelectedPrompt(productPrompt);
    showDetailsModalHandler();
  }


  useEffect(() => {
    (async () => {
      isMounted.current = !isMounted.current;
      const url = search ? `prompt/allprompts/${userID}?page=${currentPage}&limit=10&search=${search}` : `prompt/allprompts/${userID}?page=${currentPage}&limit=10`;
      const { data } = await axiosOpen.get(url);
      if (!isMounted.current) return;
      const modifiedResponse = data?.usersPrompts ? structuredClone(data.usersPrompts) : [];
      modifiedResponse.length > 0 &&
        modifiedResponse.forEach((product) => {
          product.promptrequest.title = product.promptrequest.title.trim();
          product.promptresponse.title = product.promptresponse.title.trim();

          product.promptrequest.description = product.promptrequest.description.trim();
          product.promptresponse.description = product.promptresponse.description.trim();

          // product.promptrequest.features = product.promptrequest.features.trim()
          //   .replace("  ", " ")
          //   .replace(/\n•/g, ",")
          //   .replace(/•/g, "")
          //   .split(",");

          product.promptresponse.features = product.promptresponse.features
            .replace(", ", "")
            .replace("\n\n", "")
            .replace(/\n•/g, "\n")
            .replace(/\n[0-9]./g, "\n")
            .replace('",', "")
            .replace("•", "")
            .split("\n");
        });
      setPromptsList(modifiedResponse);
      setTotalItems(data.totalPrompts);
    })();

    return () => {
      isMounted.current = false;
    }
  }, [currentPage, search]);

  return (
    <Container className="users-prompts-container bg-white">
      <Row>
        <Col>
          <Modal show={showDetailsModal} onHide={showDetailsModalHandler} className="custom-modal">
            <Modal.Header closeButton className="border-0">
              <Modal.Title>Product Details</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
              <Tabs defaultActiveKey="unoptimized-data" id="justify-tab-example" className="mb-3 custom-tab" justify>
                <Tab eventKey="unoptimized-data" title="Product  Data">
                  <Container>
                    <Row>
                      <Col className="mb-2">
                        <b>Product Title:</b>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mb-3">{selectedPrompt?.promptrequest?.title}</Col>
                    </Row>
                    {/* <Row>
                      <Col className="mb-2">
                        <b>ASIN:</b>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mb-3">{selectedPrompt?.asin}</Col>
                    </Row> */}
                    <Row>
                      <Col className="mb-2">
                        <b>Product Description:</b>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mb-3">{selectedPrompt?.promptrequest?.description}</Col>
                    </Row>

                    {/* <Row>
                      <Col className="mb-2">
                        <b>Product Features:</b>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mb-3">
                        <ul>
                          {selectedPrompt?.promptrequest?.features.length > 0 &&
                            selectedPrompt?.promptrequest?.features.map((feature) => <li>{feature}</li>)}
                        </ul>
                      </Col>
                    </Row> */}
                  </Container>
                </Tab>
                <Tab eventKey="optimized-data" title="Optimized Data">
                  <Container>
                    <Row>
                      <Col className="mb-2">
                        <b>Product Title:</b>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mb-3">{selectedPrompt?.promptresponse?.title}</Col>
                    </Row>
                    {/* <Row>
                      <Col className="mb-2">
                        <b>ASIN:</b>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mb-3">{selectedPrompt?.asin}</Col>
                    </Row> */}
                    <Row>
                      <Col className="mb-2">
                        <b>Product Description:</b>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mb-3">{selectedPrompt?.promptresponse?.description}</Col>
                    </Row>

                    <Row>
                      <Col className="mb-2">
                        <b>Product Features:</b>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mb-3">
                        <ul>
                          {selectedPrompt?.promptresponse?.features.length > 0 &&
                            selectedPrompt?.promptresponse?.features.map((feature) => <li>{feature}</li>)}
                        </ul>
                      </Col>
                    </Row>
                  </Container>
                </Tab>
              </Tabs>
            </Modal.Body>
          </Modal>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex align-items-center justify-content-between mb-4">
          <h2 className="m-0 primary-font-size">users prompts</h2>
          <InputGroup size="sm" style={{ "width": "200px" }}>
            <Form.Control
              placeholder="Search by Username"
              aria-label="Small"
              aria-describedby="inputGroup-sizing-sm"
              onChange={(e) => setSearch(e.target.value)}
            />
          </InputGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table striped hover responsive className="users-prompts-table m-0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Username</th>
                <th>Email</th>
                <th>Title</th>
                {/* <th>ASIN</th> */}
                <th>Description</th>
                {/* <th>Features</th> */}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {promptsList.length > 0 &&
                promptsList.map((prompt) => (
                  <tr key={prompt._id}>
                    <td>{`${prompt.userid.fname}${prompt.userid.lname}`}</td>
                    <td>{`${prompt.userid.username}`}</td>
                    <td>{`${prompt.userid.email}`}</td>
                    <td>{`${prompt.promptrequest.title.slice(0, 15)}...`}</td>
                    {/* <td><a href={prompt.link} target="_blank" className="text-decoration-none">{`${prompt.asin ? prompt.asin : '---'}`}</a></td> */}
                    <td>{`${prompt.promptrequest.description.slice(0, 15)}...`}</td>
                    {/* <td>{`${prompt.promptrequest.features[0].slice(0, 15)}...`}</td> */}
                    <td>
                      <Button className="font-size-secondary" onClick={() => handleView(prompt)}>
                        VIEW
                      </Button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </Col>
      </Row>
      <Row>
        <Col className="pt-3">
          <Paginations
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            totalItemsPerPage={"10"}
            totalItems={totalItems}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default UserPrompt;
